exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dashboard-container[data-v-afd61b8a]{margin-top:-10px}.dashboard-container[data-v-afd61b8a] .smartwidget .widget-header .widget-header__toolbar a{display:inline-block;text-decoration:none;text-align:center;height:24px;line-height:28px;padding:0;margin:0;color:#333;min-width:35px;position:relative;font-family:Arial, Helvetica, sans-serif;border:none !important}\n", ""]);

// exports
